module.exports = __webpack_public_path__ + "img/20n.cecc5a26.png";